import React from 'react'

const ProfileItem = ({image, name, occupation, socials, className}) => {
  return (
    <div className={className}>
      <div className='card-body profile-card pt-4 d-flex flex-column align-items-center'>
        <img src={image} alt='Profile' className='rounded-circle' />
        <h2>{name}</h2>
        <h5 className='text-center'>{occupation}</h5>
        <div className='social-links mt-2'>
          {socials?.map((social) => (
            <a
              key={social.name}
              href={social.link}
              target='_blank'
              className={social.name}
              rel='noreferrer'
            >
              <i className={`bi bi-${social.name}`}></i>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ProfileItem;